import React, { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="navbar-inner">
        <a href="#accueil" className="navbar-logo">
          <span className="navbar-logo-name g-text">Geek AI</span>
        </a>
        <ul className="navbar-links">
          <li><a href="#accueil">Accueil</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#processus">Comment ça marche</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
        <a href="#contact" className="g-btn navbar-cta">Démarrer un projet</a>
      </div>
    </nav>
  );
}
